import React from "react";
import { Row, Col } from "react-bootstrap";
import "./footer.styles.scss";

const Footer = () => {
    return (
        <Row>
            <Col lg={12} className="footer">GigsClassroom 2022</Col>
        </Row>
    )
}

export default Footer;